import { hbs } from 'ember-cli-htmlbars';
export default hbs("<li {{on \"click\" (fn @onClick @tag.name)}} role=\"button\" ...attributes>\n  <a tabindex=\"-1\" href=\"#\">{{tag-with-count @tag}}</a>\n</li>")